<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>attach_file</mat-icon></div>
    <div class="la-header-text">
      <h2 class="cf-dlg-title">Adjuntar cuadro de amortización</h2>
      <p class="cf-dlg-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="!saving; else savingTpl">
    <div class="cf-dlg-body">
      <div class="la-info" *ngIf="hasCurrentFile">
        <mat-icon>info</mat-icon>
        <span>Este préstamo ya tiene un cuadro de amortización adjunto. Si subes uno nuevo, sustituirá al actual.</span>
      </div>

      <div class="la-field" [class.la-field--invalid]="submitted && !selectedFile">
        <label class="cf-dlg-upload-btn la-upload" for="loan-attachment-input">
          <mat-icon class="la-upload__icon">file_upload</mat-icon>
          <span *ngIf="!selectedFile">Seleccionar Excel (.xlsx)</span>
          <span *ngIf="selectedFile" class="la-upload__name">{{ selectedFile.name }}</span>
        </label>
        <input #fileInput id="loan-attachment-input" class="la-upload__input" type="file" accept=".xlsx" (change)="onFileSelected($event)">
        <div class="cf-field__error la-error" *ngIf="submitted && !selectedFile && !saveError"><mat-icon>error</mat-icon> Selecciona el fichero Excel</div>
        <button *ngIf="selectedFile" type="button" class="la-link" (click)="clearFile(fileInput)">Quitar fichero</button>
      </div>

      <div class="cf-dlg-mismatch la-alert" *ngIf="saveError">
        <mat-icon>error</mat-icon>
        <span>{{ saveError }}</span>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()">
        <mat-icon>file_upload</mat-icon> Adjuntar
      </button>
    </div>
  </ng-container>

  <ng-template #savingTpl>
    <app-loading-state message="Adjuntando cuadro de amortización…"></app-loading-state>
  </ng-template>
</div>
